// Client V2 common imports
const { USER_FOLLOWING_CHANGE } = require('client-v2/common/models/user/actions')
// Container imports
const ProfileUserRecord = require('./record')

/* eslint-disable complexity */
function profileUserReducer(state, { type, payload }) {
  // This is basically a copy-paste of client-v2/common/models/user/reducer
  // Sanity check
  if (!payload || !(state instanceof ProfileUserRecord)) {
    return state
  }
  // Ignore actions that don't refer to this user
  if (payload.userId !== state.id) {
    return state
  }
  switch (type) {
    case USER_FOLLOWING_CHANGE:
      return state.merge({
        isFollowing: payload.isFollowing
      })
    default:
      return state
  }
}
/* eslint-enable complexity */

module.exports = profileUserReducer
